<div
  class="measure-names-pill"
  capraTooltip
  [tooltipContent]="tooltipContent"
  [tooltipContentIsHtml]="true"
  [tooltipInteractive]="false"
  [tooltipDelay]="[750, 0]"
  tooltipPlacement="bottom"
>
  <div
    class="field-dropzone"
    [class.field-drag]="isDragging && !disabled"
    dndDropzone
    [dndDisableDropIf]="disabled"
    [dndAllowExternal]="true"
    (dndDrop)="onFieldDrop()"
  ></div>
  <div class="measure-names-label" [class.disabled]="disabled">Measure Names</div>
</div>
